export default {
    status: {
        acknowledged: "Rendelt",
        created: "Létrehozva",
        sent: "Rendelt",
        confirmed: "Rendelt",
        not_confirmed: "Nincs megrendelve",
        delivery_email: "Szállítva",
        delivery_rejected: "Szállítási kivétel",
        delivery_rejected_not_confirmed: "Szállítási kivétel",
        shipped: "Szállítva",
        delayed: "Késleltetett",
        preparing: "Előkészítés",
        processing: "Feldolgozás",
        processed: "Feldolgozott",
        submitted: "Rendelt",
        delivery_not_received: "Szállítva",
        shipment_exception: "Szállítva",
        pre_pending_approval: "Függőben levő",
        pending_approval: "Függőben levő",
        approved: "Jóváhagyott",
        not_approved: "Nem jóváhagyott",
        canceled: "Lemondva",
        returned: "Visszatért",
        lost_shipment: "Elveszett szállítmány",
        delivery_not_confirmed: "Kiszállítva",
        delivered: "Kiszállítva",
        delivery_received: "Kiszállítva",
        refurbished: "Visszaküldés befejezve",
        returned_to_office: "Visszatért az irodába",
        return_to_employer: "Visszaadva a munkáltatónak",
        return_pickup_scheduled: "Átvétel ütemezve",
        return_pickup_completed: "Átvétel befejezve",
        return_pickup_excluded: "Átvétel kizárva",
        return_pickup_submitted: "Átvétel elküldve",
        return_pickup_finalized: "Átvétel véglegesítve",
        disposed: "Eldobott",
        damaged: "Sérült",
        transferred: "Áthelyezve",
        transfer_received: "Átutalás fogadva"
    }
}